<template>
  <div>
    <div class="title">Пожалуйста выберите центр и клиента (опционально), чтобы получить список покупок или добавить
      товар
    </div>

    <div class="add-tab">
      <div class="add-tab__item">
        <div class="add-tab__title">Выберите центр</div>

        <el-select
            class=" "
            style="width: 100%;"
            v-model="filterForm.departmentId"
            placeholder="Название центра"
            name="department"
            type=""
        >
          <el-option
              label="item.title"
              value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="add-tab__item">

        <div class="add-tab__title">Выберите клиента</div>

        <el-select
            class=""
            style="width: 100%;"
            v-model="filterForm.user"
            placeholder="Название центра"
            name="department"
            type=""
        >
          <el-option
              label="item.title"
              value="item.id"
          ></el-option>
        </el-select>

      </div>
      <div class="add-tab__item">
        <el-button @click="visibleDialogAddSale = true" class="add-tab__button" type="primary">Добавить покупки
        </el-button>

      </div>
    </div>

    <add-sail
        :visible="visibleDialogAddSale"
        @close="visibleDialogAddSale = false"
        />

  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex"
import AddSail from "@/components/dialog/TheAddSail.vue"

export default {
  name: "MainInformation",
  data() {
    return {
      visibleDialogAddSale: false,
      loading: false,
      filterForm: {}
    }
  },
  computed: {
    ...mapGetters("visit", {device: "getDevices"}),
    visit() {
      return this.$route.params.visit;
    },
  },
  components: {
    AddSail
  },
  methods: {
    ...mapActions({
      setVisit: "visit/SET_DATA",
    }),
    confirmSave() {
      this.$confirm('Отправить данные пользователю?')
          .then(() => {
            this.closeVisit(true)
          })
    },
    closeVisit(save = false) {

      let params = {
        params: {
          send: save,
        },
      }

      this.loading = true;
      this.$api.visit
          .close(this.visit.id, save ? params : {})
          .then(() => {
            this.$notify.success({
              title: save ? "Визит закрыт" : "Черновик сохранен",
            })

            this.setVisit()

            this.$router.push({
              name: "visit.list",
            })

          })
          .catch((res) => {
            this.$notify.error({
              title: "Упс..",
              message: res.response.data.message,
            });
          })
          .finally(() => {
            this.loading = !!0
          })
    },
  }

}

</script>

<style lang="scss" scoped>
.title {
  margin-top: 16px;
  font-size: 15px;
  line-height: 20px;
  color: #8E8E93;
}

.add-tab {
  margin: 14px 0;
  display: flex;
  justify-content: space-between;
  align-items: end;
  gap: 20px;

  &__item {
    width: 100%;
  }

  &__title {
    margin-bottom: 8px;

    font-size: 14px;
    line-height: 22px;
    font-weight: bold;

    color: #606266;
  }

  &__button {
    width: 100%;
    padding: 12px 0 !important;
  }
}
</style>